import { createSlice } from "@reduxjs/toolkit";
import { CartSliceProp, CartType } from "../../Type/Application/Ecommerce/Product";
import { toast } from "react-toastify";

const initialState: CartSliceProp = {
  cart: [],
  total: null,
  tax: 10
};

const CartSlice = createSlice({
  name: "CartSlice",
  initialState,
  reducers: {
    incrementData: (state, action) => {
      const productId = action.payload.item.id;
      state.cart = state.cart.map((item) => {
        if (productId === item.id) {
          if (item.total == item.quantite_stock) {
            toast.info('la quantite demandée est trop, Veuillez faire un approvisionnement')
            return item
          }
          return { ...item, total: item.total + 0.5, sum: item.prix_unitaire * (item.total + 0.5) };
        } else {
          return item;
        }
      });
    },

    decrementData: (state, action) => {
      state.cart = state.cart.map((item) => (action.payload === item.id && item.total > 0.5 ? { ...item, total: item.total - 0.5, sum: item.prix_unitaire * (item.total - 0.5) } : item));
    },

    removeCartData: (state, action) => {
      state.cart = state.cart.filter((item) => item.id !== action.payload);
    },

    clearCart: (state) => {
      state.cart = [];
    },

    addToCartData: (state, action) => {
      const { item, quantity } = action.payload;

      // ❌ Empêcher d'ajouter si quantité 0 ou négative
      if (quantity <= 0) {
        toast.info("Impossible d'ajouter un produit avec une quantité de 0");
        return;
      }

      const productId = item.id;

      const existing = state.cart.find(p => p.id === productId);

      if (existing) {
        const newTotal = existing.total + quantity;

        // ❌ Vérifier stock
        if (newTotal > existing.quantite_stock) {
          toast.info("La quantité demandée dépasse le stock disponible");
          return;
        }

        existing.total = newTotal;
        existing.sum = existing.prix_unitaire * newTotal;
      } else {
        // ❌ Empêcher d'ajouter si quantité 0
        if (quantity <= 0) {
          toast.info("La quantité doit être supérieure à zéro");
          return;
        }

        state.cart.push({
          ...item,
          total: quantity,
          sum: item.prix_unitaire * quantity,
        });
      }
    },

    setTotal: (state, action) => {
      const { id, total } = action.payload;
      const product = state.cart.find(p => p.id === id);

      if (product) {

        // ❌ Si total <= 0 → retirer du panier
        if (total < 0) {
          state.cart = state.cart.filter(p => p.id !== id);
          toast.info("Le produit a été retiré car la quantité est 0");
          return;
        }

        // ❌ Vérification stock
        if (total > product.quantite_stock) {
          toast.info("Quantité supérieure au stock disponible");
          return;
        }

        product.total = total;
        product.sum = product.prix_unitaire * total;
      }
    },

    selectCartTotalQuantity: (state) => {
      state.total = state.cart.reduce((acc, item) => acc + (item.total ?? 0), 0);
    }
    
  },
});
export const { incrementData, clearCart, decrementData, removeCartData, addToCartData, setTotal } = CartSlice.actions;

export default CartSlice.reducer;